import { UserRole } from '@shared/utils/base-auth';
import { AppRoutes } from './app-routes.industrial-cam';

export const DefaultRoutes: Partial<Record<UserRole, string>> = {
  [UserRole.SuperAdmin]: `/${AppRoutes.Files}`,
  [UserRole.Commander]: `/${AppRoutes.Files}`,
  [UserRole.Supervisor]: `/${AppRoutes.Files}`,
  [UserRole.HRAdmin]: `/${AppRoutes.Users}`,
  [UserRole.Kiosk]: `/${AppRoutes.Downloads}`,
};
